<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A7SpiO/tc-custom/9781466845664.jpg?1730583383470" alt="This image is the cover for the book Lords of the White Castle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lords of the White Castle
      </h1>
      <p class="bookDescription body article font2">
        <p>Westminster, 1184-- in the court of King Henry, playful competition is about to turn into something far more serious. Young courtier Fulke FitzWarin would not be an obvious companion for Prince John, but the boy from the Welsh Marches is there as a reward for his family's loyalty to the crown. The FitzWarins are as proud as they are true, and when Fulke is accused by John of cheating during a game of chess, he cannot help but respond. Thus begins a bitter rivalry that will resonate throughout their lives.<br/><br/>The FitzWarins dream of reclaiming their family estate and title, Lords of the White Castle. After this quarrel with Fulke, however, John's vindictiveness leads to Fulke renouncing his allegiance and becoming a rebel outlaw.<br/><br/>In romance, too, Fulke is no closer to fulfilling his heart's desire. A youthful dalliance means nothing compared to his love for the spirited Maude le Vavasour, but marriage in medieval England is more about alliance than about love, and Fulke can only watch helplessly as Maude's father arranges a more suitable match. After all, what can Fulke offer Maude apart from a lifetime on the run....<br/><br/>With all the intrigue and pageantry that bring the twelfth century vividly to life, this award-winning novelist spins us an irresistible tale of a deadly rivalry and an impossible love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Chadwick
      </h2>
      
      <p class="authorDescription body article">Elizabeth Chadwick is the pen name of Nancy Herndon. She was born in St. Louis, Missouri, and now lives in El Paso, Texas, with her husband. She earned her degrees in English and journalism from the University of Missouri-Columbia and has graduated from the El Paso Citizens&rsquo; Police Academy. She has published several novels under the pen name Elizabeth Chadwick, such as&#160;<I>Elusive Lovers</I>,&#160;<I>Wanton Angel</I>,&#160;<I>and Widow&rsquo;s Fire</I>. As Nancy Herndon, she has written the Elena Jarvis Series, beginning with&#160;<I>Acid Bath</I>&#160;and&#160;<I>Widow&rsquo;s Watch</I>. As Nancy Fairbanks, she has written the Carolyn Blue culinary mystery beginning with&#160;<I>Crime Brulee</I>. She has avid interests in travel, food, history, and classical music.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f18e683